module.exports = __webpack_public_path__ + "fonts/LatoLatin-SemiboldItalic.ded399f.ttf";